import styled from "styled-components";
import { themeTypes } from "../../shared/styled/Theme";

export const StyledHorizontalScoreboardNavigator = styled.div`
  width: 40px;
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.16);
  background: ${(props) =>
    props.theme.type == themeTypes.light
      ? props.theme.rgba.white_100
      : props.theme.rgba.black_33};
  opacity: 0.9;
  cursor: pointer;
  visibility: hidden;

  &.--show {
    visibility: visible;
  }
`;
